import React, { useState } from "react";
import Styles from "./ChildTransaction.module.css";
import { CircularProgress, Modal, Tooltip } from "@mui/material";
import { Close, Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Payouts from "../../Schedule/Payouts/Payouts";
import Settlement from "../../Schedule/Settlement/Settlement";
import { convertDate, formatDateElement } from "../../../../commons/FormatDate";
import { getWalletActivities } from "../../../../Services/Schedule/schedule";

const ChildTransaction = ({ open, handleClose, data, parentData }) => {
  const [repId, setRepId] = useState("");
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();

  const [openPayout, setOpenPayouts] = useState(false);
  const [settlement, setSettlement] = useState({
    status: false,
    repId: "",
    schId: "",
    contractId: null,
  });
  const [walletActivities, setWalletActivities] = useState({
    open: false,
    loading: false,
    data: [],
  });

  const handleViewTransactions = async () => {
    setWalletActivities({ open: true, loading: true, data: [] });
    const res = await getWalletActivities({
      bilateralContractId: parentData?.bilateralContractUniqueId,
    });
    setWalletActivities({
      open: true,
      loading: false,
      data: res?.data?.data?.page || [],
    });
  };



  return (
    <>
      {settlement?.status && (
        <Settlement
          open={settlement?.status}
          handleClose={() =>
            setSettlement({
              status: false,
              repId: "",
              schId: "",
              contractId: null,
            })
          }
          paymentData={settlement}
          paymentScreen={true}
          // isInLdcCharge={true}
          heading={
            settlement?.contractId
              ? "LDC Charge Details"
              : "Transaction Details"
          }
        />
      )}
      {openPayout && (
        <Payouts
          open={openPayout}
          handleClose={() => setOpenPayouts(false)}
          viewOnly={true}
          id={parentData?.bilateralContractId}
          repId={repId}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.childTransactionModal}`}>
          <div className="modalHeading">
            View Daily Contract
            <Close
              onClick={handleClose}
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          <div className={Styles.parentListingContainer}>
            <div className={Styles.upperParentCont}>
              <div>Contract Id</div>
              <div>{parentData?.bilateralContractUniqueId || "-"}</div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Self Listing Id</div>
              <div>
                {
                  (role === "consumer"
                    ? parentData?.name?.split("-")?.[0]?.includes("C")
                      ? parentData?.name?.split("-")?.[0]
                      : parentData?.name?.split("-")?.[1]
                    : parentData?.name?.split("-")?.[1]?.includes("G")
                      ? parentData?.name?.split("-")?.[1]
                      : parentData?.name?.split("-")?.[0]
                  )?.split("_")?.[0]
                }
              </div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Counterparty</div>
              <div>
                {role === "consumer"
                  ? `${parentData?.generatorName}`
                  : role === "generator"
                    ? `${parentData?.consumerName}`
                    : `${parentData?.consumerName}-${parentData?.generatorName}`}
              </div>
            </div>

            <div className={Styles.upperParentCont}>
              <div>Total Contract Value (₹)</div>
              <div>{(parentData?.scheduledAmount || 0)?.toFixed(2)}</div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Total Blocked Amount (₹)</div>
              <div>{(parentData?.amountBlocked || 0)?.toFixed(2)}</div>
            </div>
            <div className={Styles.upperParentCont}>
              <div> LDC Charges</div>
              <div>
                <RemoveRedEyeIcon
                  style={{ fontSize: "14px", color: "#f1935c" }}
                  onClick={() => {
                    setSettlement({
                      status: true,
                      repId: "",
                      schId: "",
                      contractId: parentData?.bilateralContractId,
                    });
                  }}
                />
              </div>
            </div>
            <div className={Styles.upperParentCont_status}>
              <div>Schedule</div>
              <div
                className={`${
                  parentData?.status === "COMPLETED"
                    ? "accepted"
                    : parentData?.status === "PENDING"
                      ? "pending"
                      : "rejected"
                }`}
              >
                {parentData?.status === "COMPLETED"
                  ? "Completed"
                  : parentData?.status === "PENDING"
                    ? "Ongoing"
                    : "Rejected"}
              </div>
            </div>
            <div className={Styles.upperParentCont}>
              <div>Transactions</div>
              <div>
                <RemoveRedEyeIcon
                  style={{ fontSize: "14px", color: "#f1935c" }}
                  onClick={handleViewTransactions}
                />
              </div>
            </div>
          </div>
          <div className={Styles.tableContainer}>
            <div className="tableHeading display_flex_row">
              <div style={{ width: "10%" }}>Date</div>
              <div style={{ width: "20%" }}>Time Range</div>
              <div style={{ width: "10%" }}>Sch Qty (MWH)</div>
              <div style={{ width: "15%" }}>
                <div>Est. Amount(₹)</div>
                <Tooltip
                  title={"Estimated amount as per schedule quantum."}
                  arrow
                >
                  <Info
                    style={{
                      fontSize: 16,
                      color: "#666",
                      marginLeft: "4px",
                    }}
                  />
                </Tooltip>
              </div>
              <div style={{ width: "16%" }}>Amount Blocked(₹)</div>
              <div style={{ width: "5%" }}>Breakdown</div>
              <div style={{ width: "5%" }}>Payouts</div>
            </div>
            <div className={`scroll_bar_y ${Styles.childTransactionTable}`}>
              {Object.entries(
                (data || []).reduce((groups, ele) => {
                  const key = ele?.scheduleId ?? "unknown";
                  if (!groups[key]) groups[key] = [];
                  groups[key].push(ele);
                  return groups;
                }, {}),
              ).map(([scheduleId, groupItems]) => (
                <div
                  key={scheduleId}
                  style={{
                    border: "1px solid #F1935C",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    padding: "8px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {groupItems.map((ele, index) => (
                    <div key={index} className="tableDetails display_flex_row">
                      <div style={{ width: "10%" }}>
                        {convertDate(ele?.date)}
                      </div>
                      <div style={{ width: "20%" }}>
                        {ele?.scheduleStartTime?.split(":")?.[0]}:
                        {ele?.scheduleStartTime?.split(":")?.[1]} to{" "}
                        {ele?.scheduleEndTime === "23:59:59"
                          ? "24:00"
                          : `${ele?.scheduleEndTime?.split(":")?.[0]}:${
                              ele?.scheduleEndTime?.split(":")?.[1]
                            }`}
                      </div>
                      <div style={{ width: "10%" }}>
                        {(ele?.volume || 0)?.toFixed(2)}
                      </div>
                      <div style={{ width: "15%" }}>
                        {(ele?.amount || 0)?.toFixed(2)}
                      </div>
                      <div style={{ width: "16%" }}>
                        {(ele?.amountBlocked || 0)?.toFixed(2)}
                      </div>
                      <div style={{ width: "5%" }}>
                        <RemoveRedEyeIcon
                          style={{ fontSize: "14px", color: "#f1935c" }}
                          onClick={() => {
                            setSettlement({
                              status: true,
                              repId: ele?.repScheduleId,
                              schId: ele?.scheduleId,
                              contractId: null,
                            });
                          }}
                        />
                      </div>
                      <div style={{ width: "5%" }}>
                        <RemoveRedEyeIcon
                          style={{ fontSize: "14px", color: "#f1935c" }}
                          onClick={() => {
                            setOpenPayouts(true);
                            setRepId(ele?.repScheduleId);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={walletActivities.open}
        onClose={() =>
          setWalletActivities({ open: false, loading: false, data: [] })
        }
      >
        <div className={`popupModal ${Styles.childTransactionModal}`}>
          <div className="modalHeading">
            Wallet Transactions
            <Close
              onClick={() =>
                setWalletActivities({ open: false, loading: false, data: [] })
              }
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          {walletActivities.loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "32px",
              }}
            >
              <CircularProgress size={28} style={{ color: "#f1935c" }} />
            </div>
          ) : (
            <div className={Styles.tableContainer}>
              <div className="tableHeading display_flex_row">
                <div style={{ width: "20%" }}>Listing ID</div>
                <div style={{ width: "14%" }}>Counter Party</div>
                {/* <div style={{ width: "18%" }}>Contract ID</div> */}
                <div style={{ width: "18%" }}>Transaction Date</div>
                <div style={{ width: "18%" }}>Transaction Amount (₹)</div>
                <div style={{ width: "18%" }}>Type</div>
                <div style={{ width: "12%" }}>Action</div>
              </div>
              <div className={`scroll_bar_y ${Styles.childTransactionTable}`}>
                {walletActivities.data.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "24px",
                      color: "#999",
                      fontSize: "12px",
                    }}
                  >
                    No transactions found.
                  </div>
                ) : (
                  walletActivities.data.map((item) => (
                    <div
                      key={item.id}
                      className="tableDetails display_flex_row"
                    >
                      <div style={{ width: "20%" }}>
                        {item.listingId.split("_")[0] || "-"}
                      </div>
                      <div style={{ width: "14%" }}>
                        {item.counterPartyName || "-"}
                      </div>
                      {/* <div style={{ width: "18%" }}>
                        {item.bilateralContractUniqueId || "-"}
                      </div> */}
                      <div style={{ width: "18%" }}>
                        {convertDate(item.dateTime) || "-"}
                      </div>
                      <div style={{ width: "18%" }}>
                        {(item.amount || 0).toFixed(2)}
                      </div>
                      <div
                        style={{
                          width: "18%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.paymentType?.split("_")?.join(" ") || "-"}
                      </div>
                      <div
                        style={{ width: "12%" }}
                        className={
                          item?.activity === "CREDIT" ||
                          item?.activity === "RELEASED"
                            ? "accepted"
                            : "rejected"
                        }
                      >
                        {item.activity || "-"}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ChildTransaction;
